import { Injectable } from '@angular/core';

@Injectable()
export class SairService {

  constructor() { }

  public sair(urlDestino) {

    var req = new XMLHttpRequest();


    req.open('POST', 'logout', true);
    req.onreadystatechange = function() {
      console.log(req.readyState);
      if (req.readyState === 4) {
          console.log(req.responseText);
          window.open(urlDestino,"_self");
      }
    };

    req.setRequestHeader('Accepts','text/plain');
    req.setRequestHeader('Content-type','text/plain; charset=utf-8');
    req.setRequestHeader('Access-Control-Allow-Origin','*');
    req.setRequestHeader('Access-Control-Allow-Methods','GET, POST, PUT, DELETE, OPTIONS');
    req.setRequestHeader('Access-Control-Allow-Headers','origin, content-type, accept, x-requested-with, x-xsrf-token,  sid');
    req.setRequestHeader('Access-Control-Max-Age','1800');
    req.withCredentials = true;

    req.send(null);
  }

}



// WEBPACK FOOTER //
// C:/Disco D/Projetos/central-cliente/src/app/angular-base-ui/sair.service.ts